import React from 'react';
import { Moon, Sun } from 'lucide-react';
import { useTheme } from '../i18n/ThemeContext';

export default function ThemeToggle() {
  const { theme, toggle } = useTheme();
  const isDark = theme === 'dark';
  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-white/5 hover:bg-white/10 border border-white/15 text-white text-xs font-semibold tracking-wider transition-colors"
      title={isDark ? 'Light table' : 'Royal felt'}
    >
      {isDark ? <Sun className="w-3.5 h-3.5" /> : <Moon className="w-3.5 h-3.5" />}
      <span>{isDark ? 'LIGHT' : 'FELT'}</span>
    </button>
  );
}
